import React from 'react';
import { ErrorReporter } from '../../../errorHandling/ErrorReporter';

export class RenderErrorsHandler extends React.Component<{ errorReporter: ErrorReporter; children?: React.ReactNode }> {
  static displayName = 'RenderErrorsHandler';

  componentDidMount() {
    if (!this.props.errorReporter) {
      console.error(`<RenderErrorsHandler/> mount without ErrorReporter instance. Check mobx stores inject.`);
    }
  }

  componentDidCatch(error: Error, { componentStack }: React.ErrorInfo): void {
    if (this.props.errorReporter) {
      const attributes: Record<string, string> = {};
      if (componentStack) {
        attributes.componentStack = componentStack;
      }
      this.props.errorReporter.reportError(error, attributes);
    }
  }

  render() {
    return this.props.children || null;
  }
}
